/** @format */

import {
	Flex,
	Box,
	Fade,
	Button,
	ButtonGroup,
	Container,
	Grid,
	GridItem,
	Text,
	Tag,
} from '@chakra-ui/react';
import Image from 'next/image';

import Avatar from './avatar';
import Categories from './categories';
import CoverImage from './cover-image';
import Link from 'next/link';
import {getDomainFontFamily} from '../utils';
import {decode} from 'html-entities';
import {fonts} from '../styles/js/fonts';
import {fontSizes} from '../styles/js/typography';
import {textStyles} from '../styles/js/textStyles';
import {colors} from '../styles/js/colors';

export default function NewsPostHeader({
	title,
	coverImage,
	date,
	author,
	categories,
	subdomain,
}) {
	const domainFontFamily = getDomainFontFamily(subdomain);
	const titleDomainFontFamily = getDomainFontFamily(subdomain);
	const height = {base: '640px', md: '560px', lg: '480px'};
	const {firstName, lastName, name} = author.node;

	let fontSize = {base: '40px', md: '48px'};
	let backgroundColour = colors.aqua[500];
	let newsDomain = '';

	if (categories.edges.length && categories.edges[0].node.name) {
		newsDomain = categories.edges[0].node.name;

		if (newsDomain.toLowerCase().includes('college')) {
			backgroundColour = colors.aqua[500];
		}
		if (newsDomain.toLowerCase().includes('garden')) {
			backgroundColour = colors.pine[500];
		}
		if (newsDomain.toLowerCase().includes('harlaxton')) {
			backgroundColour = colors.gold[500];
		}
	}

	const formattedDate = new Date(date).toLocaleDateString('en-US', {
		day: 'numeric',
		month: 'long',
		year: 'numeric',
	});

	const Divider = () => (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='4'
			height='4'
			viewBox='0 0 4 4'
			fill='none'>
			<circle cx='2' cy='2' r='2' fill='white' />
		</svg>
	);

	const Author = () => {
		return (
			<>
				<Flex direction='row' alignItems={'center'} gap={2}>
					<Text fontFamily={domainFontFamily} fontSize='16px' color='white'>
						{firstName && lastName ? `${firstName} ${lastName}` : name}
					</Text>
					<Divider />
					<Text fontFamily={domainFontFamily} fontSize='16px' color='white'>
						{formattedDate}
					</Text>
				</Flex>
			</>
		);
	};

	return (
		<Box as={'section'} position='relative'>
			<Box position='relative'>
				<Box
					position='relative'
					width='100%'
					height={height}
					bg={backgroundColour}
					display='flex'
					alignItems='center'
					color='white'>
					<Container position='relative' maxW='container.xl' mx='auto'>
						<Grid padding={'16px'}>
							<GridItem
								w={{base: '100%', md: '75%'}}
								className='textComponent-grid'>
								{categories
									? categories.edges.map((catItem, index) => (
											<Tag
												key={`${index}-${catItem.name}`}
												variant='solid'
												borderRadius={0}
												backgroundColor={'#ffffffd9'}
												color={backgroundColour}
												fontFamily={fonts.copernicusGalaxyMedium}
												fontSize={fontSizes.xs}>
												{catItem.node.name}
											</Tag>
									  ))
									: null}

								{title ? (
									<Text
										{...textStyles.text5Xl}
										fontSize={fontSize}
										lineHeight={{base: '48px', md: '64px'}}
										pt={{base: '32px'}}
										pb={{base: '32px'}}
										fontFamily={
											titleDomainFontFamily
												? titleDomainFontFamily
												: domainFontFamily
										}>
										{decode(title)}
									</Text>
								) : null}
							</GridItem>

							<GridItem pb={{base: '40px'}}>
								<Author />
							</GridItem>
						</Grid>
					</Container>
				</Box>
			</Box>
		</Box>
	);
}
